import { useProjectsWipFilterOptionsQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import type { Store } from "../Store";

export const useFetchFilterOptions = (store: Store) => {
  useProjectsWipFilterOptionsQuery({
    onCompleted(data) {
      store.setFilterOptions(data);
    },
    ...onError(),
  });
};
